<template>
	
	<v-dialog
	    v-model="visible"
		persistent
	    width="1000"
		
		class="select-dialog"
		ref="selectDialog"
		eager
	>
		<v-card class="ma-0 pa-0 white">
			<v-card-title class="text-subtitle-1 white--text info" ref="selectDialogTitle">
				{{title}}
			</v-card-title>			
			
			<v-card-text  style="height:500px;" class="pa-0 ma-0">
                <div class="d-flex flex-column" style="position:relative;width:100%;height:100%">
                    <div flat class="flex-grow-0 flex-shrink-0 mt-2 d-flex flex-row">
                        <div class="form-item form-item-width-3 mb-1">
                            <label class="form-item-label mt-1 mr-1">选择模块:</label>
                            <div class="form-item-value" style="position:relative;height:100%">
                                <div style="position:absolute;top:0;bottom:0;left:0;right:0;">
                                    <v-select v-model="selectedModule" :items="modules" label="" hide-details flat solo outlined dense return-object
                                    item-text="caption" full-width>
                                    </v-select>
                                </div>
                            </div>
                            <v-btn class="ml-2 mb-2 right-round" @click="handleApplyFilter" color="primary" :disabled="btnLoadModuleFuncDisabled">
                                <v-icon>mdi-file-find</v-icon>
                                加载
                            </v-btn>
                        </div>	
                    </div>

                    <v-divider></v-divider>

                    <!-- div style="position:absolute;top:0;bottom:0;left:0;right:0;" class="pa-1 flex-grow-1 flex-shrink-1" -->
                    <div class="pa-0 flex-grow-1 flex-shrink-1" style="position:relative;">    
                        <div style="position:absolute;top:0;bottom:0;left:0;right:0;overflow-y: scroll;">
                            <module-function-select-table
                                ref="moduleFunctionSelectTable"
                                class="module-function-table"
                            >
                            </module-function-select-table>
                        </div>
                    </div>
                </div>    
			</v-card-text>
			
			<v-divider></v-divider>
			
			<v-card-actions class="d-flex flex-row ma-2">
			  <v-spacer></v-spacer>
			  <v-btn
				color="blue-grey"
				class="left-round mr-2"
				@click="setVisible(false)"
				
			  >
				<span class="px-2"><v-icon>mdi-file-cancel-outline</v-icon></span>
				取消
			  </v-btn>
			  <v-btn
				color="success"
				class="right-round mr-2"
				@click="handleSave"
			  >				
				确定
				<span class="px-2"><v-icon>mdi-content-save-move-outline</v-icon></span>
			  </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	
</template>

<script>
	import {default as ModuleApi} from "../../../../api/smp/sys/ModuleApi.js";
	import {default as ModuleFunctionApi} from "../../../../api/smp/sys/ModuleFunctionApi.js";
	import {default as ModuleFuncTypeApi} from "../../../../api/smp/sys/ModuleFuncTypeApi.js";
	import ModuleFunctionSelectTable from "./ModuleFunctionSelectTable.vue";
	import {default as DragSupport} from '../../../../util/drag.js';
	
	export default {
		name: 'ModuleFunctionSelectDialog',
		components: {
			'module-function-select-table':ModuleFunctionSelectTable
		},
		props:['singleSelect','condType','resultCheck'],
		data: () => ({
			visible:false,
			modules: [],
			selectedModule: [],
			moduleFunctionTypes:[]
		}),
		methods:{
			async  errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			async  infoMsg(title,text){
				await this.$dialog.info({
					text: text,
					title: title
				});
			},
			clear(){
				this.selectedModule=[];
				let table = this.$refs.moduleFunctionSelectTable;
				if(table)
					table.clear();
			},
			setVisible(v){
                /*
				this.visible=v;
				if(this.visible==true)
					DragSupport.bind(this.$refs.selectDialog.$refs.dialog);
				else
					DragSupport.unbind(this.$refs.selectDialog.$refs.dialog);
                */
                this.visible=v;
                let dialogEl = this.$refs.selectDialog.$refs.dialog;
                console.log(this.$refs.selectDialog);
				if(this.visible==true)
					DragSupport.bind(dialogEl,this.$refs.selectDialogTitle);
				else
					DragSupport.unbind(dialogEl);    
			},
			handleApplyFilter(){
				this.loadModuleFunctions();
			},
			async handleSave(){
				let me = this;
				let selectedModuleFunctions= this.$refs.moduleFunctionSelectTable.getSelectedModuleFunctions();
				if((!selectedModuleFunctions)||(selectedModuleFunctions.length<1)){
					me.errMsg('错误','还没有选择模块/功能');
					return;
				}
				
				if(me.resultCheck){
					let checkResult = await me.resultCheck(selectedModuleFunctions);
					
					if(checkResult==false){
						return;
					}
					
					selectedModuleFunctions.forEach(function(func){
						me.modules.forEach(function(module){
							if(func.moduleId==module.moduleId)
								func.moduleName=module.moduleName;
						})
					});
					
					me.$emit("moduleFunctionSelected",selectedModuleFunctions);
					me.setVisible(false);					
				}				
			},
			loadModules() {
				let me = this;
				ModuleApi.queryAllModule().then(function(resp) {
					let data = resp.data;
					if ((!data) || (!(data.code)) || (data.code != 200) || (!data.data)) {
						let msg = data.msg;
						msg = ((!msg) || (msg == '')) ? '获取模块信息失败' : msg;
						throw new Error(msg);
						return;
					}
			
					let modules = data.data.modules;
					//修改类型名
					modules.forEach(function(module) {
						module.caption = module.moduleId + " - " + module.moduleCode + " - " + module.moduleName;
					});
					me.modules = modules;
				}).catch(function(err) {
					me.errMsg('错误', '获取模块信息失败:' + err.message);
				});
			},
			loadModuleFunctions() {
				let me = this;
				if (!me.selectedModule)
					return;
				me.$refs.moduleFunctionSelectTable.loadModuleFunctions(me.selectedModule.moduleId);
				me.$refs.moduleFunctionSelectTable.setEditing(true);
			},
			loadModuleFuncTypes(){
				let me = this;
				ModuleFuncTypeApi.queryModuleFuncType().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取模块功能类型信息失败':msg;
						throw new Error(msg);
						return;
					}
			
					let moduleFuncTypes = data.data.moduleFuncTypes;
					console.log("request moduleFuncTypes returned:");
					console.log(moduleFuncTypes);
					me.moduleFunctionTypes = moduleFuncTypes
				}).catch(function(err){
					console.log(err);
					me.errMsg('错误','获取模块功能类型信息失败:'+err.message);
				});
			},
			
			getModuleFunctionTypeName(typeId){
				let me = this;
				let name ="";
				if(!me.moduleFunctionTypes)
					return "";
				me.moduleFunctionTypes.forEach(function(type){
					if(type.typeId==typeId){
						name = type.typeName;
						return;
					}
				});	
				return name;
			},
			getModuleFunctionTypeNames(types){
				let me = this;
				let name ="";
				types.forEach(function(typeId){
					name = name+me.getModuleFunctionTypeName(typeId)+",";
				});
				return name;
			}
		},
		computed:{
			btnLoadModuleFuncDisabled() {
				return !this.selectedModule;
			},
			title(){
				let selectMode= "";
				if(this.singleSelect==true)
					selectMode = "单选";
				else 
					selectMode = "多选";
						
				let typeName ="模块/功能";	
					
				if(this.condType){
					typeName = this.getModuleFunctionTypeNames(this.condType);
				}
						
				return selectMode+'('+typeName+')';
			}
		},
		created(){
			this.loadModules();
			this.loadModuleFuncTypes();
		}
	}
</script>

<style scoped>
	.select-dialog{
		border-radius: 4px;
		width:1000px;
		height:550px !important;
		background-color: white;
	}
	.full-fill{
		width:100%;
		height:100%;
        
	}
	
	.module-function-table {
		padding:0px;
		margin:0px;
		
		height: 100%;
		max-width: 100%;
		max-height: 100%;
	}
</style>
